import type { ApiFileUploadType } from 'api/types/ApiFileUploadType';

import { apiCreateS3PresignedUpload } from './apiCreateS3PresignedUpload';
import { apiSendFileToS3PresignedUpload } from './apiSendFileToS3PresignedUpload';

type Args = {
  file: File;
  fileType: ApiFileUploadType;
};

export async function apiUploadFileToS3({ file, fileType }: Args) {
  const presignedUpload = await apiCreateS3PresignedUpload({ file, fileType });

  const s3FileId = await apiSendFileToS3PresignedUpload({
    file,
    presignedUpload,
  });

  return s3FileId;
}
